import { render, staticRenderFns } from "./QuizPoll.vue?vue&type=template&id=79c34883&"
import script from "./QuizPoll.vue?vue&type=script&lang=js&"
export * from "./QuizPoll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports